import { LabelVariant } from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';

export const FormApplicationType = {
  LOAN_APPLICATION: 'LoanApplication',
  BROKER_APPLICATION: 'BrokerApplication',
};

export const OverrideBadge = {
  LOCAL: { title: 'Local', variant: LabelVariant.YELLOW },
  GLOBAL: { title: 'Global', variant: LabelVariant.BLUE },
  GLOBAL_WITH_OVERRIDES: { title: 'Global with Overrides', variant: LabelVariant.ORANGE },
};

export const FormBundleElementType = {
  FORM: 'Form',
  DOCUMENT_TYPE: 'DocumentType',
};

export const DocumentVersionType = {
  LAST_DOCUMENT: 'LastDocument',
  ALL_DOCUMENTS: 'AllDocuments',
};

export const FormType = {
  HTML: 'Html',
  PDF: 'Pdf',
  CUSTOM: 'Custom',
};

export const FieldType = {
  SIGNING: 'helloSignTag',
  DYNAMIC: 'field',
  MULTIPLE: 'multiple',
};

export const FormSchemaType = {
  STRING: 'string',
  BOOL: 'bool',
  RATE: 'rate',
  CURRENCY: 'currency',
  PERCENT: 'percent',
  INT: 'int',
  DOUBLE: 'double',
  LONG: 'long',
  TODAY_X_DAYS: 'today-x-days',
  DATE_X_BUSINESS_DAYS: 'date-x-business-days',
  DATE: 'date',
  IMAGE: 'image',
  HAND_WRITING_SIGNATURE: 'hand-writing-signature',
  BLANK_SIGNATURE_LINE: 'blank-signature-line',
  NOTARY_MULTILINE_TEXT: 'notary-multiline-text',
  // Mirror SkynetCore CommonTypeNames (TextWrapping / MultilineText); the PDF renderer lays these out top-anchored.
  TEXT_WRAPPING: 'text-wrapping',
  MULTILINE_TEXT: 'multiline-text',
};

export const PDF_BLOCK_TEXT_FIELD_TYPES = [
  FormSchemaType.TEXT_WRAPPING,
  FormSchemaType.MULTILINE_TEXT,
  FormSchemaType.NOTARY_MULTILINE_TEXT,
];

// Field types whose PDF renderer ignores a vertical alignment (block text, checkboxes, signatures, images).
export const PDF_VERTICAL_ALIGNMENT_EXCLUDED_TYPES = [
  ...PDF_BLOCK_TEXT_FIELD_TYPES,
  FormSchemaType.BOOL,
  FormSchemaType.HAND_WRITING_SIGNATURE,
  FormSchemaType.BLANK_SIGNATURE_LINE,
  FormSchemaType.IMAGE,
];

export const DefaultTemplateElementPosition = {
  [FieldType.MULTIPLE]: {
    x: 50,
    width: 340,
    height: 28,
  },
  [FieldType.SIGNING]: {
    x: 50,
    y: 50,
    width: 180,
    height: 14,
  },
  [FieldType.DYNAMIC]: {
    x: 50,
    y: 50,
    width: 180,
    height: 14,
  },
};

export const CheckboxRenderType = {
  Checkbox: {
    label: 'square',
    value: 'Checkbox',
    inputType: 'checkbox',
  },
  Radiobutton: {
    label: 'circle',
    value: 'Radiobutton',
    inputType: 'radio',
  },
};

export const ActionNameType = {
  ADD_DAYS_WITH_FORMAT: 'addDaysWithFormat',
  ADD_BUSINESS_DAYS_WITH_FORMAT: 'addBusinessDaysWithFormat',
  CURRENCY_SIGN_FORMAT: 'formatCurrency',
  RATE_PERCENTAGE_FORMAT: 'formatRate',
  PERCENT_PERCENTAGE_FORMAT: 'formatPercent',
  FORMAT_NUMERIC: 'formatNumeric',
  FORMAT_DATE: 'formatDate',
  INVERSE_BOOL_VALUE: 'inverseBoolValue',
  FORMAT_SIGNATURE: 'formatSignature',
  STATE_SPELLED_OUT: 'formatStateSpelledOut',
};

export const HorizontalAlignmentType = {
  LEFT: 'Left',
  CENTER: 'Center',
  RIGHT: 'Right',
};

export const VerticalAlignmentType = {
  TOP: 'Top',
  MIDDLE: 'Middle',
  BOTTOM: 'Bottom',
};

export const VERTICAL_ALIGNMENT_JUSTIFY_CONTENT = {
  [VerticalAlignmentType.TOP]: 'flex-start',
  [VerticalAlignmentType.MIDDLE]: 'center',
  [VerticalAlignmentType.BOTTOM]: 'flex-end',
};

export const FormDynamicFieldSchemaGroupType = {
  FIELDS: 'fields',
  CATEGORIES: 'categories',
};
export const FormViewerNavigationType = {
  URL: 'Url',
  STATE: 'State',
};
export const NavigationStateType = {
  VIEW: 'view',
  EDIT: 'edit',
};

export const LoxDocumentTypeName = 'Letter of Explanation (LOX)';

export const GeographicalState = {
  US: 'US',
  NATIONAL: 'National',
};

export const FormTemplateTypeNewApi = {
  PDF: 'Pdf',
  PDF_WITH_METADATA: 'Pdf.WithMetadata',
  HTML_EMPTY: 'Html.Empty',
  HTML_FILLED: 'Html.Filled',
  EMPTY_HTML: 'EmptyHtml',
};

export const FormsVisibility = {
  FOR_COMPANY: 'Visible.ForCompany',
  FOR_LOAN: 'Visible.ForLoan',
};

export const FormTypeCompatibilityEnum = {
  [FormTemplateTypeNewApi.PDF]: FormType.PDF,
  [FormTemplateTypeNewApi.PDF_WITH_METADATA]: FormType.PDF,
  [FormTemplateTypeNewApi.HTML_FILLED]: FormType.HTML,
  [FormTemplateTypeNewApi.HTML_EMPTY]: FormType.HTML,
};

export const FormTypeNewApi = {
  BROKER: 'Broker',
  BORROWER: 'Borrower',
};

export const FormOverrideTemplateType = {
  NEW_EMPTY_HTML: 'NewEmptyHtml',
  EXISTS_FORM_CONTENT: 'ExistsFormContent',
  NEW_PDF_CONTENT: 'NewPdfContent',
};

export const SCRIBAN_MARKER = '{{';

export const PrismEditorBlockReason = {
  SCRIBAN: 'scriban',
  SEEDED_SYSTEM_FORM: 'seededSystemForm',
};

export const TAGS_CATEGORY_NAME = 'All Tags';
export const TAG_NAME_DYNAMIC_FIELD = 'Tag Name';
export const TAG_ASSIGNED_DATE_DYNAMIC_FIELD = 'Tag Assigned Date';

export const FormBundleExpressionType = {
  FILLED: 'Filled',
  EMPTY: 'Empty',
};

export const FormDateFormat = {
  DATE_ONLY: 'MM/dd/yyyy',
  DATE_WITH_TIME: 'MM/dd/yyyy hh:mm tt',
};

export const DynamicFieldPostfixSymbol = {
  PERCENT: '%',
};

export const DynamicFieldPrefixSymbol = {
  DOLLAR: '$',
};

export const DefaultDecimalPositions = {
  [FormSchemaType.RATE]: 3,
  [FormSchemaType.PERCENT]: 2,
  [FormSchemaType.CURRENCY]: 2,
  [FormSchemaType.DOUBLE]: 2,
  [FormSchemaType.INT]: 0,
  [FormSchemaType.LONG]: 0,
};

export const DYNAMIC_FIELD_DEFAULT_MULTIPLIER = 1;

export const NUMERIC_FIELDS_WITH_DECIMAL_POSITIONS = [
  FormSchemaType.PERCENT,
  FormSchemaType.INT,
  FormSchemaType.DOUBLE,
  FormSchemaType.LONG,
];

export const NUMERIC_FIELDS_WITH_THOUSANDS_SEPARATOR = [
  FormSchemaType.INT,
  FormSchemaType.DOUBLE,
  FormSchemaType.LONG,
];

export const DefaultWithThousandsSeparator = {
  [FormSchemaType.INT]: false,
  [FormSchemaType.LONG]: false,
  [FormSchemaType.DOUBLE]: true,
};

export const DYNAMIC_FIELDS_WITH_MULTIPLIER = [
  FormSchemaType.RATE,
  FormSchemaType.PERCENT,
  FormSchemaType.CURRENCY,
  FormSchemaType.INT,
  FormSchemaType.DOUBLE,
  FormSchemaType.LONG,
];

export const MAX_MULTIPLIER = Number.MAX_SAFE_INTEGER;

export const MAX_DECIMAL_POSITIONS = 10;

export const DisclosureType = {
  LOAN_ESTIMATE: 'LoanEstimate',
  CLOSING_DISCLOSURE: 'ClosingDisclosure',
};

export const FormPurposeType = {
  TAX_AUTHORIZATION: 'TaxAuthorization',
  RECORDING: 'Recording',
};

export const FormPurpose = {
  IRS_FORM_8821: 'IrsForm8821',
  IRS_FORM_8821_BORROWER_1: 'IrsForm8821Borrower1',
  IRS_FORM_8821_BORROWER_2: 'IrsForm8821Borrower2',
  IRS_FORM_8821_BORROWER_3: 'IrsForm8821Borrower3',
  IRS_FORM_8821_BORROWER_4: 'IrsForm8821Borrower4',
  HALCYON_CONSENT_1177_BORROWER_1: 'HalcyonConsent1177Borrower1',
  HALCYON_CONSENT_1177_BORROWER_2: 'HalcyonConsent1177Borrower2',
  HALCYON_CONSENT_1177_BORROWER_3: 'HalcyonConsent1177Borrower3',
  HALCYON_CONSENT_1177_BORROWER_4: 'HalcyonConsent1177Borrower4',
  SECURITY_INSTRUMENT: 'SecurityInstrument',
  RIDER: 'Rider',
  EXHIBIT: 'Exhibit',
  SUBORDINATE: 'Subordinate',
};

export const DYNAMIC_FIELD_PATH_SEPARATOR = ' / ';
